/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Clear_All_FiltersInputs */



/**
* | output |
* | --- |
* | "Clear all filters" |
*
* @param {Editor_Clear_All_FiltersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_clear_all_filters = /** @type {((inputs?: Editor_Clear_All_FiltersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Clear_All_FiltersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tous les filtres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Filter löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutti i filtri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить все фильтры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todos los filtros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所有筛选条件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてのフィルターをクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी फ़िल्टर साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar todos os filtros")
	return /** @type {LocalizedString} */ ("Clear all filters")
});